import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/", { replace: true }); return; }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        // clear hash
        window.history.replaceState({}, "", window.location.pathname);
        if (data.is_admin) navigate("/admin", { replace: true, state: { user: data } });
        else navigate("/login", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
    // `api` is a stable module import; `done` is a ref (never a dep);
    // `data` is a local inside the async IIFE — none belong in the deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash, navigate, setUser]);

  return (
    <div className="pt-40 container-w mono-label" data-testid="auth-callback">Signing in…</div>
  );
}
